export const INTEGRATION_SALESFORCE = 'Salesforce'